export const PLACEHOLDER_THUMBNAIL =
  '/images/local-market/placeholder-thumbnail.png';
